// extracted by mini-css-extract-plugin
module.exports = {"Name":"User_Name__gVsOp","Email":"User_Email__Cbo5N"};